var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagPortugal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 3.75H12.1875V26.25H4.6875C2.6175 26.25 0.9375 24.57 0.9375 22.5V7.5C0.9375 5.43 2.6175 3.75 4.6875 3.75Z",
    fill: "#2B6519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 26.25L11.25 26.25L11.25 3.75L25.3125 3.75C27.3825 3.75 29.0625 5.43 29.0625 7.5L29.0625 22.5C29.0625 24.57 27.3825 26.25 25.3125 26.25Z",
    fill: "#EA3323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M25.3125 3.75H4.6875C2.61656 3.75 0.9375 5.42906 0.9375 7.5V22.5C0.9375 24.5709 2.61656 26.25 4.6875 26.25H25.3125C27.3834 26.25 29.0625 24.5709 29.0625 22.5V7.5C29.0625 5.42906 27.3834 3.75 25.3125 3.75ZM28.125 22.5C28.125 24.0506 26.8631 25.3125 25.3125 25.3125H4.6875C3.13687 25.3125 1.875 24.0506 1.875 22.5V7.5C1.875 5.94937 3.13687 4.6875 4.6875 4.6875H25.3125C26.8631 4.6875 28.125 5.94937 28.125 7.5V22.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.3125 4.6875H4.6875C3.13406 4.6875 1.875 5.94656 1.875 7.5V8.4375C1.875 6.88406 3.13406 5.625 4.6875 5.625H25.3125C26.8659 5.625 28.125 6.88406 28.125 8.4375V7.5C28.125 5.94656 26.8659 4.6875 25.3125 4.6875Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.6875C13.8388 19.6875 15.9375 17.5888 15.9375 15C15.9375 12.4112 13.8388 10.3125 11.25 10.3125C8.66117 10.3125 6.5625 12.4112 6.5625 15C6.5625 17.5888 8.66117 19.6875 11.25 19.6875Z",
    fill: "#FFFF55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6519 12.6835L8.84717 12.6778V15.8944C8.85092 16.5244 9.10123 17.1197 9.5531 17.5697C10.0134 18.0281 10.6144 18.2813 11.2453 18.2813C11.8865 18.2813 12.4903 18.031 12.945 17.5781C13.3997 17.1244 13.6509 16.5225 13.6509 15.8831V12.6835H13.6519Z",
    fill: "#EA3323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPortugal);
export default __webpack_public_path__ + "static/media/flag_portugal.27a9d9981a43c3ee53a423fe338bec50.svg";
export { ForwardRef as ReactComponent };